import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

// Mirrors AutomatedSurveyAssignmentPolicy::viewDashboard, which only
// InstructionAdminPolicyCheck::before() passes: Owner, Admin and Instruction Admin.
// No permission grants this dashboard.
export const canViewEvaluationAssignmentsDashboard = ({ gateKeeper, gate }) =>
    !!(
        gateKeeper.user?.is_admin ||
        ['Owner', 'Admin', 'Instruction Admin'].some(role => gate.$store.getters['User/hasRole'](role))
    );

export default [
    {
        name: 'evaluation-assignments-dashboard',
        path: '/evaluation-assignments-dashboard',
        component: () => import('@/pages/evaluation-assignments-dashboard/EvaluationAssignmentsDashboard.vue'),
        props: true,
        meta: {
            title: 'Evaluation Assignments',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: canViewEvaluationAssignmentsDashboard,
        },
    },
];
